import { type PropsWithChildren } from 'react';
import { animated, useSpring, easings } from '@react-spring/web';

interface WordProps {
  fontSize: number;
  color: string;
  x: number;
  y: number;
}

export const Word = ({
  fontSize,
  color,
  x,
  y,
  children,
  ...rest
}: PropsWithChildren<WordProps>) => {
  const styles = useSpring({
    fontSize,
    fill: color,
    transform: `translate(${x}px, ${y}px)`,
    config: {
      easing: easings.easeOutBack,
    },
  });

  return (
    <animated.text
      style={{
        textAnchor: 'middle',

        ...styles,
      }}
      {...rest}
    >
      {children}
    </animated.text>
  );
};
